export default __webpack_public_path__ + "close_white.35ef4d.svg";